import { Link, useHistory } from "react-router-dom";
import { useState, useEffect } from "react";
import { domain } from "config.js";

function Item({ data, refno, ImageCache }) {

    const history = useHistory();

    useEffect(() => {

        async function loadCoverImage() {
            var response = await fetch(domain + "/int-getFiles", { method: "POST", body: JSON.stringify({ ref: (refno + ""), cover: true, type: "slideshow" }) }).catch(err => console.log(err));
            if (!response) return;
            var data = (await response.json())[0];
            data = data ? data : "";


            if (!ImageCache.images.result[refno]) {
                var images = { ...ImageCache.images };
                images.result[refno] = data;
                // console.log("COVER IMAGE ", images.result[refno], refno);

                ImageCache.setImages(images);
            }
        }

        loadCoverImage();
    }, []);

    // console.log("My Image", refno, ImageCache.images.result[refno]);

    return (
        <div className="col-12 col-md-6 col-lg-4 mt-4">
            <Link to={`/show?ref=${refno}`} style={{ textDecoration: "none" }}>
                <div className="card property m-auto">
                    <div className="card-pic" style={{ backgroundImage: `url("${ImageCache?.images?.result[refno]}"` }}></div>
                    <div className="card-body card-background text-center">
                        <h4 className="card-title city">{data?.type ?? ""}</h4>
                        <p className="card-text">NEW {String.prototype.toUpperCase.call(data?.type ?? "")} IN {String.prototype.toUpperCase.call(data?.location ?? "")} WITH TOP-NOTCH FACILITIES</p>
                        <p className="info">REF: {refno} | REGION: {data?.region ?? ""} | {data?.bedrooms ?? ""} BEDROOM</p>
                        <p className="info">PRICE: {monetize(data?.price ?? "")}</p>
                    </div>
                </div>
            </Link>
        </div>
    );
}

function monetize(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " €";
}

export default Item;